// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__6Azf2","location":"LocationSection_location__srogQ"};